import { render } from "./HomepageOfficialsBlock.vue?vue&type=template&id=5c4d71e6"
import script from "./HomepageOfficialsBlock.vue?vue&type=script&lang=js"
export * from "./HomepageOfficialsBlock.vue?vue&type=script&lang=js"

import "./HomepageOfficialsBlock.vue?vue&type=style&index=0&id=5c4d71e6&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__